export function gtag_report_conversion(url) {
  var callback = function() {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    send_to: 'AW-999276223/tXUgCOOi2fMBEL_9vtwD',
    event_callback: callback,
  });
  return false;
}
